import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/TallyIntegration/TallyHome';

const TallyHome = () => ((orgContainer(InnerComponent)));
export default TallyHome;
